import { lucidClassNames } from '../../util/style-helpers';

export const ComplexTableSvgPath =
	'M1857 57v10h-70V57h70zm756 0v10h-131V57h131zM700 57v10H587V57h113zm322 0v10H872V57h150zm-760 ' +
	'0v10H46V57h216zm1354-22v10h-104V35h104zm125 0v10h-104V35h104zm156 0v10h-110V35h110zm167 ' +
	'0v10h-104V35h104zm143 0v10h-104V35h104zm406 0v10h-131V35h131zM700 35v10H587V35h113zm148 ' +
	'0v10H724V35h124zm154 0v10H872V35h130zm-766 0v10H46V35h190zm1236 0v10h-104V35h104zM353 ' +
	'13v10H46V13h307zm983 0v10h-104V13h104zm136 0v10h-104V13h104zm144 0v10h-104V13h104zm125 ' +
	'0v10h-104V13h104zm186 0v10h-140V13h140zm137 0v10h-104V13h104zm143 0v10h-104V13h104zm406 ' +
	'0v10h-131V13h131zm-275 0v10h-104V13h104zm112 0v10h-74V13h74zM700 13v10H587V13h113zm148 ' +
	'0v10H724V13h124zm194 0v10H872V13h170zm-493 0v10H425V13h124zm651 0v10h-104V13h104z';

export const SimpleTableSvgPath =
	'M483 13v10H46V13h437zm215 0v10H561V13h137zm165 0v10H743V13h120zm246 0v10H908V13h201zm165 ' +
	'0v10h-120V13h120zm171 0v10h-126V13h126zm151 0v10h-106V13h106zm151 0v10h-106V13h106zm191  ' +
	'0v10h-146V13h146zm163 0v10h-118V13h118zm167 0v10h-122V13h122zm128 0v10h-83V13h83zm225 0v10h-180V13h180z';

export const cxBackgroundGray = lucidClassNames.bind(
	'&-LoadingSkeleton-backgroundGray'
);

export const cxBackgroundNeutral = lucidClassNames.bind(
	'&-LoadingSkeleton-backgroundNeutral'
);

export const cxBackgroundGrayStrokeNeutralFill = lucidClassNames.bind(
	'&-LoadingSkeleton-grayStroke-neutralFill'
);
